import { Typography } from "@mui/material";

const BackgroundPageLoader = () => {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                margin: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.59)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                flexDirection: 'column'
            }}
        >
            <img src={'https://motor-uat-s3.choiceinsurance.in/logo/car-loader.gif'} alt="loading" style={{ width: 300, transform: 'scaleX(-1)' }} />
            <Typography variant="h5" sx={{ mb: 1, color: '#fff', margin: '10px 20px !important' }}>Preparing your workspace... CRM-PRIME is almost ready.</Typography>
        </div>
    );
};
export default BackgroundPageLoader;    